module.exports = __webpack_public_path__ + "static/media/mb_map_sm.5b729601.jpg";